"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverlayPortal = void 0;
var useSelector = KalturaPlayer.ui.redux.useSelector;
var createPortal = KalturaPlayer.ui.createPortal;
var PORTAL_CLASS = '.overlay-portal';
var OverlayPortal = function (_a) {
    var children = _a.children;
    var targetId = useSelector(function (state) { return state.config.targetId; });
    var playerContainer = document.getElementById(targetId) || document;
    return createPortal(children, playerContainer.querySelector(PORTAL_CLASS));
};
exports.OverlayPortal = OverlayPortal;
//# sourceMappingURL=index.js.map